import { combineReducers } from "redux";
import mainReducer from "@/bit/reducers/reducers.main-reducer";
import modalsReducer from "@/bit/reducers/reducers.modals-reducer";
import headerReducer from "@/bit/reducers/reducers.header-reducer";
import FormReducer from "@/reducers/form-reducer";
import retargetingReducer from "@/reducers/retargeting";

const REDUCERS_LIST = {
  main: mainReducer,
  modals: modalsReducer,
  header: headerReducer,
  form: FormReducer,
  retargeting: retargetingReducer,
};

const rootReducers = () =>
  combineReducers({
    ...REDUCERS_LIST,
  });

export default rootReducers;
